<template>
    <router-link :class="inverse ? 'btn-primary': 'btn-outline-primary'" class="btn" v-if="to && !disabled" :to="to">
        <slot></slot>
    </router-link>
    <a :class="inverse ? 'btn-primary': 'btn-outline-primary'" class="btn" v-else-if="href && !disabled" :href="href">
        <slot></slot>
    </a>
    <button :disabled="disabled" :class="inverse ? 'btn-primary': 'btn-outline-primary'" class="btn" v-else @click="$emit('click', $event)">
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        to: {
            type: Object
        },
        href: {
            type: String
        },
        disabled: {
            default: false,
            type: Boolean
        },
        inverse: {
            default: false,
            type: Boolean
        }
    }
}
</script>

<style scoped lang="scss">

</style>
